import { render, staticRenderFns } from "./CreateDocumentYearReview.vue?vue&type=template&id=4e55a50f&scoped=true&"
import script from "./CreateDocumentYearReview.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentYearReview.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentYearReview.vue?vue&type=style&index=0&id=4e55a50f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e55a50f",
  null
  
)

export default component.exports